import * as Yup from 'yup';
import { requiredField } from '../../../lib/helperFuncs';
import { matchIsValidTel } from 'mui-tel-input';
import { validateFileSize } from '../../../lib/helperFuncs';

export const newOrganisationValidation = Yup.object({
  // step 1
  country: 
        Yup.string()
          .required(requiredField),
  orgIdentifierEnAbbreviation:
        Yup.string()
          .required(requiredField)
          .matches(/^[A-Za-z]+$/, 'Παρακαλώ προσθέστε έγκυρη μορφή Φορέα'),
  organisationsName:
          Yup.string()
            .required(requiredField),
});

export const newCollectionValidation = Yup.object({
  // step 1
  collectionsTitle: 
        Yup.string()
          .required(requiredField),
  orgIdentifierCountryId:
          Yup.string()
            .required(requiredField)
});

export const newDocumentValidation = Yup.object({
  // step 1
  collectionsUniqueCode: 
        Yup.string()
          .required(requiredField),
  organisationsIdentifier:
          Yup.string()
            .required(requiredField),
  documentsTitle:
        Yup.string()
          .required(requiredField)
});

export const newProjectValidation = Yup.object({
  // step 1
  countryId:
          Yup.string()
            .required(requiredField),
  projectTitle:
        Yup.string()
          .required(requiredField)
});

export const editOrganisationValidation = Yup.object({
  organisationsEnNameEn: Yup
    .string()
    .required(requiredField),
  orgIdentifierEnAbbreviation: Yup
    .string()
    .required(requiredField),
  organisationsEmail: Yup
    .string()
    .required(requiredField)
    .email('Μη αποδεκτή μορφή Email')
    .matches(/^\w+([.-]?\w+)*@\w+([-]?\w+)*(\.\w{2,5}(?!\.\w))$/, 'Μη αποδεκτή μορφή Email'),
  organisationsWebsite: Yup
    .string()
    .required(requiredField),
  organisationsTelephone: Yup.string()
    .required(requiredField)
    .test('phone_number', 'Παρακαλώ προσθέστε έγκυρη μορφή τηλεφώνου', (value) => matchIsValidTel(value || '')),
  orgIdentifierFullAddress: Yup
    .string()
    .required(requiredField),
  organisationsCountry: Yup
    .string()
    .required(requiredField),
  orgIdentifierComments: Yup
    .string(),
  orgIdentifierCommentsEn: Yup
    .string()
});

export const editCollectionValidation = Yup.object({
  collectionsUniqueCode: Yup
    .string()
    .required(requiredField),
  collectionsIdentifierUniqueCode: Yup
    .string()
    .required(requiredField),
  collectionsTitle: Yup
    .string()
    .required(requiredField),
  collectionsEnTitle: Yup
    .string()
    .required(requiredField),
  collectionsDescription: Yup
    .string()
    .required(requiredField),
  collectionEnDescription: Yup
    .string()
    .required(requiredField),
  collectionInternalFlag: Yup
    .boolean()
    .nullable(),
  collectionFeaturedFlag: Yup
    .string(),
  organisationsUniqueCode: Yup
    .string()
});
export const editDocumentionValidation = Yup.object({
  documentsUniqueCode: Yup
    .string()
    .required(requiredField),
  documentIdentifier: Yup
    .string()
    .required(requiredField),
  documentsID: Yup
    .string()
    .required(requiredField),
  documentsTitle: Yup
    .string()
    .required(requiredField),
  documentsRelationOrganisation: Yup
    .string()
    .required(requiredField),
  documentsRelationCollection: Yup
    .string()
    .required(requiredField),
  documentsEnTitle: Yup
    .string()
    .required(requiredField),
  documentsType: Yup
    .string()
    .required(requiredField),
  documentsDescription: Yup
    .string()
    .required(requiredField),
  documentsEnDescription: Yup
    .string()
    .required(requiredField),
  documentsDateCreation: Yup
    .string(),
  documentsFormat: Yup
    .string()
    .required(requiredField),
  documentsDuration: Yup
    .string(),
  documentsColor: Yup
    .string()
    .nullable(),
  documentsSound: Yup
    .string()
    .nullable(),
  documentsTechnical: Yup
    .string(),
  documentsSize: Yup
    .string(),
  documentsHeight: Yup
    .string(),
  documentsWidth: Yup
    .string(),
  documentsFrameRate: Yup
    .string(),
  documentsAspectRatio: Yup
    .string(),
  documentsCopyright: Yup
    .string(),
  documentsLicence: Yup
    .string(),
  documentsComments: Yup
    .string(),
  documentsEnComments: Yup
    .string(),
  documentsVimeoYtTitle: Yup
    .string(),
  documentsVimeoYtUrl: Yup
    .string()
    .matches(
      /^(https?:\/\/)?(www\.)?([a-z0-9\\-]+\.[a-z]{2,})(\/[^\s]*)?$/i,
      'Μη αποδεκτή μορφή URL'
    ),
  documentsAttachedMediaImages: Yup
    .mixed()
    .nullable()
    .test('fileSizeMedia', 'Παρακαλώ ανεβάστε αρχείο/α μέχρι 5MB', (value) => validateFileSize(value, 5))
    .test('fileSizeMedia', 'Παρακαλώ ανεβάστε μέχρι 10 αρχεία', (value) => {
      if (!value) return true;
      return value?.length <= 10;
    }) ,
  documentsAttachedMediaFiles: Yup
    .mixed()
    .nullable()
    .test('fileSizeMedia', 'Παρακαλώ ανεβάστε αρχείο/α μέχρι 15MB', (value) => validateFileSize(value, 15))
    .test('fileSizeMedia', 'Παρακαλώ ανεβάστε μέχρι 10 αρχεία', (value) => {
      if (!value) return true;
      return value?.length <= 10;
    })

});

export const editProjectValidation = Yup.object({
  projectIdentifier: Yup
    .string()
    .required(requiredField),
  projectUniqueCode: Yup
    .string()
    .required(requiredField),
  projectTitle: Yup
    .string()
    .required(requiredField),
  projectRelationWithTypeOfProject: Yup
    .string()
    .required(requiredField),
  projectEnTitle: Yup
    .string(),
  projectAlternativeTitle: Yup
    .string(),
  projectRelationWithDocument: Yup
    .string(),
  projectBelongsTo: Yup
    .string(),
  projectLanguage: Yup
    .string(),
  projectDuration: Yup
    .string(),
  projectLicense: Yup
    .string(),
  projectKeywords: Yup
    .string(),
  projectEducational: Yup
    .string(),
  projectYear: Yup
    .string(),
  projectCountry: Yup
    .string(),
  projectsMutualGoal: Yup
    .string(),
  projectCopyrights: Yup
    .string(),
  projectComments: Yup
    .string(),
  projectOrganization: Yup
    .string(),
  projectTrainer: Yup
    .string(),
  projectLab: Yup
    .string(),
  creationTeam: Yup
    .string(),
  projectAwards: Yup
    .string(),
  projectDisplayRegion: Yup
    .string(),
  projectDescription: Yup
    .string(),             
  projectDescriptionEn: Yup
    .string(),                  
  projectFormat: Yup
    .string(),
  projectColor: Yup
    .string(),
  projectSound: Yup
    .string(),
  projectSize: Yup
    .string(),
  projectHeight: Yup
    .string(),
  projectWidth: Yup
    .string(),
  projectFrameRate: Yup
    .string(),
  projectAspectRatio: Yup
    .string(),
  projectEnComments: Yup
    .string(),
  projectEduInstitution: Yup
    .string(),
  projectEduLevel: Yup
    .string(),
  projectNumberPlayers: Yup
    .string()
});